import { type User as FirebaseUser } from 'firebase/auth'

import {
  type UserCredential,
  type ContactVerify,
  type ContactVerifyResponse,
} from 'api'
export class AuthMappers {
  mapContact(contact: ContactVerifyResponse): ContactVerify {
    return {
      exists: contact?.exists_on_identity_platform || contact?.exists_on_user_auth,
      preRegistered: contact?.exists_on_core,
    }
  }

  mapUser(user: FirebaseUser | null): UserCredential {
    return {
      uid: user?.uid || '',
      email: user?.email || '',
      name: user?.displayName || '',
      isAnonymous: !!user?.isAnonymous,
    }
  }
}
